/** Public agent booking API — no auth; calls get-agent-profile / get-agent-availability / book-agent-appointment. */

const SUPABASE_PROJECT_URL =
  import.meta.env.VITE_SUPABASE_URL || 'https://ogxgxzvxbmnszfxbiuai.supabase.co';

export const BOOKING_FUNCTIONS_BASE = `${SUPABASE_PROJECT_URL.replace(/\/$/, '')}/functions/v1`;

export async function fetchAgentProfile(slug) {
  const params = new URLSearchParams({ slug });
  const res = await fetch(`${BOOKING_FUNCTIONS_BASE}/get-agent-profile?${params.toString()}`);
  const data = await res.json().catch(() => ({}));

  if (res.status === 404) {
    return { ok: false, notFound: true, error: data.error || 'Profile not found' };
  }
  if (!res.ok) {
    return { ok: false, notFound: false, error: data.error || data.detail || 'Request failed' };
  }
  return { ok: true, data };
}

export async function fetchAgentAvailability(slug, startDate, endDate) {
  const params = new URLSearchParams({
    slug,
    start_date: startDate,
    end_date: endDate,
  });
  const res = await fetch(`${BOOKING_FUNCTIONS_BASE}/get-agent-availability?${params.toString()}`);
  const data = await res.json().catch(() => ({}));

  if (res.status === 404) {
    return { ok: false, notFound: true, error: data.error || 'Profile not found', slots: [] };
  }
  if (!res.ok) {
    return {
      ok: false,
      notFound: false,
      error: data.error || data.detail || 'Request failed',
      slots: [],
    };
  }
  return {
    ok: true,
    slots: Array.isArray(data.slots) ? data.slots : [],
    timezone: data.timezone || 'America/New_York',
    duration_minutes: data.duration_minutes || 30,
    google_connected: Boolean(data.google_connected),
  };
}

export async function bookAgentAppointment(payload) {
  const res = await fetch(`${BOOKING_FUNCTIONS_BASE}/book-agent-appointment`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.error || data.detail || 'Booking failed');
    err.status = res.status;
    throw err;
  }
  return data;
}
